import React from 'react'

export const DatasetView = () => {
  return (
    <div>
    </div>
  )
}

export default DatasetView